import React, { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PasswordField = ({ id, label, value, onChange, ...inputProps }) => {
  const [visible, setVisible] = useState(false);
  const inputType = visible ? "text" : "password";

  return (
    <div className="auth-password-field">
      <label htmlFor={id}>{label}</label>
      <div className="auth-password-control">
        <input
          id={id}
          type={inputType}
          value={value}
          onChange={onChange}
          {...inputProps}
        />
        <button
          type="button"
          className="auth-password-toggle"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? "Passwort verbergen" : "Passwort anzeigen"}
          title={visible ? "Passwort verbergen" : "Passwort anzeigen"}
        >
          {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;
